module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', {
    staticClass: "image-editor__container"
  }, [_c('el-main', {
    staticClass: "image-editor__main"
  }, [_c('image-viewer')], 1), _vm._v(" "), _c('el-footer', {
    staticClass: "image-editor__footer"
  }, [_c('slider-editor')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dcc68cc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/image-filter/image-editor/image-editor.vue
// module id = 281
// module chunks = 0